import type { SupabaseClient } from "@supabase/supabase-js";

/**
 * After `/auth/callback` handling: go to `/` when signed in; otherwise keep `?code=` on `/`
 * so a failed PKCE exchange is not silently dropped (welcome can show recovery copy).
 */
export function finishAuthCallbackNavigation(sb: SupabaseClient | null, setPathname: (path: string) => void): void {
  void (async () => {
    if (!sb) {
      window.history.replaceState({}, "", "/");
      setPathname("/");
      return;
    }
    const { data } = await sb.auth.getSession();
    if (data.session) {
      window.history.replaceState({}, "", "/");
    } else {
      const u = new URL(window.location.href);
      const qs = u.searchParams.toString();
      window.history.replaceState({}, "", `/${qs ? `?${qs}` : ""}`);
    }
    setPathname("/");
  })();
}
